var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2"
  }, [_c('router-link', {
    staticClass: "d-flex align-center text-decoration-none",
    attrs: {
      "to": "/"
    }
  }, [_c('v-img', {
    staticClass: "app-logo me-3",
    attrs: {
      "src": _vm.logo,
      "max-height": "30px",
      "max-width": "30px",
      "alt": "logo",
      "contain": "",
      "eager": ""
    }
  }), _c('v-slide-x-transition', [_c('h2', {
    staticClass: "app-title text--primary"
  }, [_vm._v(" MMMINT.AI ")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }